var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page"},[_c('about-us-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }